export const generateItemCardPlaceholders = itemCount =>
    [...new Array(itemCount)].map((_, index) => ({
        itemId: index,
        shortDescription: '',
        url: '#'
    }));
